import { serviceVersionOne } from 'Services/api/api.service';
import { UserServiceType } from './types';

const BASE_ENDPOINT_URL = '/user';

const UserService: UserServiceType = {
  getUserId: () => serviceVersionOne.get(`${BASE_ENDPOINT_URL}/id?os=web`),
  setUserPhone: phone => serviceVersionOne.put(`${BASE_ENDPOINT_URL}/phone`, { phone }),
  deleteUser: () => serviceVersionOne.delete(`${BASE_ENDPOINT_URL}/delete`),
  getUserDelete: () => serviceVersionOne.get(`${BASE_ENDPOINT_URL}/delete`),
  getNotificationsPreference: () =>
    serviceVersionOne.get(`${BASE_ENDPOINT_URL}/notification-preferences`),
  setUserDiscountInfo: params => serviceVersionOne.patch(`${BASE_ENDPOINT_URL}/coupon`, params),
  updateNotificationsPreference: params =>
    serviceVersionOne.put(`${BASE_ENDPOINT_URL}/notification-preferences`, params),
};

export default UserService;
